import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Minimal controller: just persist "seen" and remove the indicator class.
export default class extends Controller {
  static classes = ["hasUpdates"];

  // Action: click->last-update#markSeen
  async markSeen(_event) {
    try {
      const request = post("/users/last_seen_changes");
      await request.perform();
    } catch (_) {
      // ignore network errors
    }
    this.element.classList.remove("has-updates");
  }
}
